import format from 'date-fns/format';
import parse from 'date-fns/parse';

/**
 * Formats the string to "--" if string is null
 * @param {string} str - string to format
 */
export function orDash(str: string | null) {
  if (str && str.length) return str;
  return '--';
}

/**
 * Formats title to have first character of each word to be capitalized
 * @param {string} title - title to format
 */
export const formatTitle = (title: string) => {
  return title
    .split(' ')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
};

/**
 * Capitalize only the first word in a sentence
 * @param {string} text - text to format
 */
export const capitalizeFirst = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const formatHardwareTitle = (title: string) => {
  return title
    .split(/(?=[A-Z])/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
};

export const formatMilitaryTime = (time: number): string => {
  const date = parse(time.toString().padStart(4, '0'), 'HHmm', new Date());
  return format(date, 'h:mm a');
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSortedList = (list: any[], property: string) => {
  return list.sort((a, b) => {
    if (a[property] > b[property]) {
      return 1;
    }
    return -1;
  });
};

/**
 * Attempts to convert a string to JSON. Will return the JSON
 * if successful, or False if the string is not valid JSON.
 * @param jsonString - string to convert
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const tryToParseObject = (jsonString: string): any => {
  try {
    const result = JSON.parse(jsonString);

    if (result && typeof result === 'object') {
      return result;
    }
  } catch (err) {
    // no-op
  }

  return false;
};
